export default "__VITE_ASSET__796bb39a__"